/** Tightest tolerance first: the index into this list *is* the tolerance the engine is given. */
const DIFFICULTY_NAMES = ['Hard', 'Medium', 'Easy'];

/** Tolerances 4-6, wider than Easy - only useful for watching the engine, never offered by default. */
const DEBUG_DIFFICULTY_NAMES = ['Debug 4', 'Debug 5', 'Debug 6'];

/** The levels on offer, in tolerance order. Behind `DebugDifficultiesSetting`, which is off. */
export const difficultyLevels = (withDebug: boolean) =>
  withDebug ? [...DIFFICULTY_NAMES, ...DEBUG_DIFFICULTY_NAMES] : DIFFICULTY_NAMES;

/**
 * A tolerance remembered from a session that had the debug levels on would otherwise leave the row
 * with nothing selected and hand the engine a tolerance no option can name.
 */
export const clampTolerance = (tolerance: number, levels: string[]) => Math.min(tolerance, levels.length - 1);

/**
 * Easiest on the left, hardest on the right - the levels are stored the other way round because the
 * tolerance they index gets tighter as it goes. The debug levels keep their place after the three
 * real ones rather than being reversed into the middle of them.
 */
export const difficultyOptionOrder = (levels: string[]) => [
  ...levels.slice(0, DIFFICULTY_NAMES.length).reverse(),
  ...levels.slice(DIFFICULTY_NAMES.length),
];
